import z from 'zod';

export const ZodSplitMeta = z.object({
  blockId: z.uuid(),
  volume: z.number().min(0.001),
  accountId: z.uuid(),
});

export type SplitMeta = z.infer<typeof ZodSplitMeta>;
